import { SmallTableEmptyState } from '@/components/display/SmallTableEmptyState/SmallTableEmptyState';

export type EstateTabEmptyStatePropsVariant =
  | 'direct-holdings'
  | 'businesses'
  | 'trusts'
  | 'entities'
  | 'life-insurance'
  | 'client-documents'
  | 'entity-map';

export interface EstateTabEmptyStateProps {
  variant: EstateTabEmptyStatePropsVariant;
}

export function EstateTabEmptyState({ variant }: EstateTabEmptyStateProps) {
  const variantToDisplayName: Record<EstateTabEmptyStatePropsVariant, string> =
    {
      'direct-holdings': 'direct holdings',
      businesses: 'businesses',
      trusts: 'trusts',
      entities: 'entities',
      'life-insurance': 'life insurance policies',
      'client-documents': 'client documents',
      'entity-map': 'ownership',
    };

  return (
    <SmallTableEmptyState
      fill="viewport"
      heading={`No ${variantToDisplayName[variant]}`}
      description={`There are no ${variantToDisplayName[variant]} associated with this client`}
    />
  );
}
